import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import WorkspaceForm from './WorkspaceForm';

const styles = theme => ({
  content: {
    backgroundColor: theme.palette.primary.main,
    borderTop: theme.palette.component.borderOutline,
  },
});

const WorkspaceMain = props => {
  const { classes } = props;

  return (
    <React.Fragment>
      <div className={clsx(classes.content)}>
        <WorkspaceForm {...props} />
      </div>
    </React.Fragment>
  );
};

export default connect()(
  withStyles(styles)(WorkspaceMain),
);
